const RELOAD_TIMER = 300;
const SP_OBJECT = {
  ajxcartRefresh: 'cart-update',
  qtyRefresh: 'quantity-update',
  swatchUpdate: 'variant-change'
};
let users = {}
function user(eventName, callback) {
  if (users[eventName] === undefined) {
    users[eventName] = []
  }
  users[eventName] = [...users[eventName], callback];
  return function unuser() {
    users[eventName] = users[eventName].filter((cb) => {
      return cb !== callback
    });
  }
};
function live(eventName, data) {
  if (users[eventName]) {
    users[eventName].forEach((callback) => {
      callback(data)
    })
  }
}
function animate() {
  document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
}
['load', 'scroll', 'resize'].forEach(eventName => window.addEventListener(eventName, animate));
function getClickable(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
const getScrollTop = (element) => {
  let offsetTop = 0
  do {
    if (!isNaN(element.offsetTop)) {
      offsetTop += element.offsetTop
    }
  } while ((element = element.offsetParent))
  return offsetTop
}
const portView = (element) => {
  const windowBottom = window.pageYOffset + window.innerHeight;
  return windowBottom >= getScrollTop(element);
}
if (!window.Shopify.designMode) {
  document.querySelectorAll('[data-fade-in]').forEach((element) => {
    ['load', 'scroll', 'shopify:section:load'].forEach((eventName) => {
      window.addEventListener(eventName, () => {
        if (!portView(element)) {
          return;
        }
        element.classList.add('fade-in');
      })
    })
  })
}
const triggerClickFocus = {};
function triggerClick(container, tagClicked = container) {
  var elements = getClickable(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  triggerClickClose();
  triggerClickFocus.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;
    document.addEventListener('keydown', triggerClickFocus.keydown);
  };
  triggerClickFocus.focusout = function() {
    document.removeEventListener('keydown', triggerClickFocus.keydown);
  };
  triggerClickFocus.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener('focusout', triggerClickFocus.focusout);
  document.addEventListener('focusin', triggerClickFocus.focusin);
  tagClicked.focus();
  if (tagClicked.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(tagClicked.type) &&
    tagClicked.value) {
    tagClicked.setSelectionRange(0, tagClicked.value.length);
  }
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  triggerShow();
}
function triggerShow() {
  const keyCont = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let nowClickedTag = null;
  let clickCont = null;
  window.addEventListener('keydown', (event) => {
    if(keyCont.includes(event.code.toUpperCase())) {
      clickCont = false;
    }
  });
  window.addEventListener('mousedown', (event) => {
    clickCont = true;
  });
  window.addEventListener('focus', () => {
    if (nowClickedTag) nowClickedTag.classList.remove('focused');
    if (clickCont) return;
    nowClickedTag = document.activeElement;
    nowClickedTag.classList.add('focused');
  }, true);
}
function triggerClickClose(tagClicked = null) {
  document.removeEventListener('focusin', triggerClickFocus.focusin);
  document.removeEventListener('focusout', triggerClickFocus.focusout);
  document.removeEventListener('keydown', triggerClickFocus.keydown);
  if (tagClicked) tagClicked.focus();
}
function escClick(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
class qtyBox extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.qtyInputupdate.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.BtTrigger.bind(this))
    );
  }
  qtyInputupdateBlank = undefined;
  connectedCallback() {
    this.requreQtyterm();
    this.qtyInputupdateBlank = user(SP_OBJECT.qtyRefresh, this.requreQtyterm.bind(this));
  }
  disconnectedCallback() {
    if (this.qtyInputupdateBlank) {
      this.qtyInputupdateBlank();
    }
  }
  qtyInputupdate(event) {
    this.requreQtyterm();
  }
  BtTrigger(event) {
    event.preventDefault();
    const pastValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (pastValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  requreQtyterm() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const qtyDecrease = this.querySelector(".qty-bt[name='minus']");
      qtyDecrease.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const qtyIncrease = this.querySelector(".qty-bt[name='plus']");
      qtyIncrease.classList.toggle('disabled', value >= max);
    } 
  }
}
customElements.define('qty-box', qtyBox);
function stdebounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function stFetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}
Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};
Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};
Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
class stModalcontent extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="stclose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }
  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    triggerClick(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    triggerClickClose(this.openedBy);
  }
}
customElements.define('modal-dialog', stModalcontent);
class stModalshower extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('a');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('qv-modal', stModalshower);
class Swatchoption extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.swatchUpdate);
  }
  swatchUpdate() {
    this.itemsUpdate();
    this.stupdateMasterId();
    this.btAddButton(true, '', false);
    this.stErrortxtRemove();
    this.updateSwatchStatuses();
    if (!this.swatch) {
      this.btAddButton(true, '', true);
      this.stInaccessible();
    } else {
      this.changeSwatchInput();
      this.includeProInf();
      this.updateDiscount();
      // Only update images if we're not reloading the page (modal context)
      if (this.dataset.updateUrl === 'false') {
        console.log('Updating images for modal, variant:', this.swatch);
        this.updateImageWithLoading();
      }
      this.stupdateURL();
    }
  }
  updateImageWithLoading() {
    console.log('updateImageWithLoading called', {
      section: this.dataset.section,
      originalSection: this.dataset.originalSection,
      updateUrl: this.dataset.updateUrl,
      element: this
    });
    
    // Find the section - try multiple ways
    let section = null;
    
    // First, try to find via closest (most reliable in modal)
    section = this.closest('section[id^="MainProduct-"]');
    if (section) {
      console.log('Found section via closest:', section.id);
    }
    
    // If not found, try finding within quickview modal
    if (!section) {
      let modal = this.closest('.quickview-block, popup-view');
      if (!modal) {
        // Try finding the modal by searching up the DOM tree
        let parent = this.parentElement;
        let depth = 0;
        while (parent && depth < 10) {
          if (parent.classList.contains('quickview-block') || 
              parent.tagName === 'POPUP-VIEW' ||
              parent.id && parent.id.startsWith('QuickAddInfo-')) {
            modal = parent;
            break;
          }
          parent = parent.parentElement;
          depth++;
        }
      }
      
      if (modal) {
        console.log('Found modal container:', modal);
        section = modal.querySelector('section[id^="MainProduct-"]');
        if (!section) {
          // Try finding in QuickAddInfo
          const quickAddInfo = modal.querySelector('[id^="QuickAddInfo-"]') || document.querySelector('[id^="QuickAddInfo-"]');
          if (quickAddInfo) {
            section = quickAddInfo.querySelector('section[id^="MainProduct-"]');
          }
        }
        if (section) console.log('Found section via modal:', section.id);
      }
    }
    
    // Try by ID variations
    if (!section) {
      const sectionIds = [
        `MainProduct-${this.dataset.section}`,
        `MainProduct-${this.dataset.originalSection || this.dataset.section}`,
        `MainProduct-quickadd-${this.dataset.originalSection || this.dataset.section}`
      ];
      
      console.log('Trying section IDs:', sectionIds);
      
      for (const sectionId of sectionIds) {
        section = document.getElementById(sectionId);
        if (section) {
          console.log('Found section by ID:', sectionId);
          break;
        }
      }
    }
    
    // Last resort: search all sections in the document
    if (!section) {
      console.log('Could not find section, trying broader search...');
      const allSections = document.querySelectorAll('section[id^="MainProduct-"]');
      console.log('Found sections:', allSections.length, Array.from(allSections).map(s => s.id));
      if (allSections.length > 0) {
        // Prefer sections within modal/quickview
        const modalSections = Array.from(allSections).filter(s => 
          s.closest('.quickview-block, popup-view, [id^="QuickAddInfo-"]')
        );
        section = modalSections.length > 0 ? modalSections[0] : allSections[0];
        console.log('Found section via broad search:', section.id);
      }
    }
    
    // If section still not found, try to find by product_detail_img container
    if (!section) {
      const productDetailImg = document.querySelector('.quickview-block .product_detail_img, [id^="QuickAddInfo-"] .product_detail_img');
      if (productDetailImg) {
        section = productDetailImg.closest('section[id^="MainProduct-"]');
        if (!section) {
          // Use the productDetailImg as our container
          section = productDetailImg.closest('section') || productDetailImg.parentElement;
          console.log('Using product_detail_img container as section');
        }
      }
    }
    
    if (!section) {
      console.error('Could not find section for image update');
      console.log('Available sections:', document.querySelectorAll('section').length);
      console.log('Modal content:', this.closest('.quickview-block, popup-view'));
      console.log('QuickAddInfo elements:', document.querySelectorAll('[id^="QuickAddInfo-"]').length);
      return;
    }
    
    // Get product_id from slider
    var product_id = null;
    const bigSlider = section.querySelector(`[id^="slider-big-"]`);
    if (bigSlider) {
      product_id = bigSlider.id.replace('slider-big-', '');
      console.log('Found product_id from slider ID:', product_id);
    } else {
      // Try to extract from any slider class
      const anySlider = section.querySelector('[class*="slider-big-"]');
      if (anySlider) {
        const classList = anySlider.className.split(' ');
        const sliderClass = classList.find(cls => cls.startsWith('slider-big-'));
        if (sliderClass) {
          product_id = sliderClass.replace('slider-big-', '');
          console.log('Found product_id from slider class:', product_id);
        }
      }
    }
    
    if (!product_id) {
      console.error('Could not find product_id');
      // Try to find slider directly without product_id
      const anyBigSlider = section.querySelector('[id^="slider-big-"]');
      if (anyBigSlider) {
        product_id = anyBigSlider.id.replace('slider-big-', '');
        console.log('Found product_id as fallback:', product_id);
      }
    }
    
    if (!product_id) {
      console.error('Could not find product_id, trying direct slider search...');
      // Last resort: find any slider-big in the modal
      const modal = this.closest('.quickview-block, popup-view, [id^="QuickAddInfo-"]') || 
                    document.querySelector('.quickview-block, [id^="QuickAddInfo-"]');
      if (modal) {
        const anySlider = modal.querySelector('[id^="slider-big-"]');
        if (anySlider) {
          product_id = anySlider.id.replace('slider-big-', '');
          section = anySlider.closest('section') || modal;
          console.log('Found product_id via direct search:', product_id);
        }
      }
    }
    
    if (!product_id) {
      console.error('Could not find product_id, cannot proceed');
      return;
    }
    
    const selectedVariantId = this.swatch.id;
    // Try multiple ways to get featured_media ID
    let selectedVariantFeaturedMediaId = null;
    if (this.swatch.featured_media) {
      selectedVariantFeaturedMediaId = this.swatch.featured_media.id || 
                                        this.swatch.featured_media.media_id ||
                                        (this.swatch.featured_media_id ? this.swatch.featured_media_id : null);
      if (selectedVariantFeaturedMediaId) {
        selectedVariantFeaturedMediaId = selectedVariantFeaturedMediaId.toString();
      }
    }
    // Also check if featured_media_id is directly on swatch
    if (!selectedVariantFeaturedMediaId && this.swatch.featured_media_id) {
      selectedVariantFeaturedMediaId = this.swatch.featured_media_id.toString();
    }
    
    console.log('Variant info:', {
      variantId: selectedVariantId,
      featuredMediaId: selectedVariantFeaturedMediaId,
      featured_media: this.swatch.featured_media,
      swatchKeys: Object.keys(this.swatch)
    });
    
    // Get all slides from both sliders - search within the section or modal
    let bigSliderWrapper = section.querySelector(`#slider-big-${product_id} .swiper-wrapper`);
    let smallSliderWrapper = section.querySelector(`#slider-small-${product_id} .swiper-wrapper`);
    
    // If not found in section, try direct search
    if (!bigSliderWrapper || !smallSliderWrapper) {
      const modal = section.closest('.quickview-block, popup-view, [id^="QuickAddInfo-"]') || 
                    document.querySelector('.quickview-block, [id^="QuickAddInfo-"]');
      if (modal) {
        bigSliderWrapper = modal.querySelector(`#slider-big-${product_id} .swiper-wrapper`);
        smallSliderWrapper = modal.querySelector(`#slider-small-${product_id} .swiper-wrapper`);
      }
    }
    
    console.log('Slider wrappers found:', {
      big: !!bigSliderWrapper,
      small: !!smallSliderWrapper,
      product_id: product_id,
      sectionId: section ? section.id : 'none'
    });
    
    if (!bigSliderWrapper || !smallSliderWrapper) {
      console.error('Could not find slider wrappers');
      console.log('Available sliders:', {
        big: document.querySelectorAll('[id^="slider-big-"]').length,
        small: document.querySelectorAll('[id^="slider-small-"]').length
      });
      return;
    }
    
    // Find modal container for loading overlay
    const modal = section.closest('.quickview-block, popup-view');
    let loadingOverlay = null;
    
    // Create and show loading overlay
    if (modal) {
      loadingOverlay = document.createElement('div');
      loadingOverlay.style.cssText = 'position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.9); z-index: 9999; display: flex; align-items: center; justify-content: center;';
      loadingOverlay.innerHTML = '<div style="text-align: center;"><div class="spinner-border" style="width: 3rem; height: 3rem; border-width: 0.3em;"></div></div>';
      const productDetailImg = section.querySelector('.product_detail_img');
      if (productDetailImg) {
        productDetailImg.style.position = 'relative';
        productDetailImg.appendChild(loadingOverlay);
      }
    }
    
    // Destroy existing swipers first
    const smallSliderEl = section.querySelector(`.slider-small-${product_id}, #slider-small-${product_id}`);
    const bigSliderEl = section.querySelector(`.slider-big-${product_id}, #slider-big-${product_id}`);
    
    if (smallSliderEl && smallSliderEl.swiper) {
      smallSliderEl.swiper.destroy(true, true);
    }
    if (bigSliderEl && bigSliderEl.swiper) {
      bigSliderEl.swiper.destroy(true, true);
    }
    
    // Get ALL slides (including hidden ones)
    const allBigSlides = Array.from(bigSliderWrapper.querySelectorAll('.swiper-slide'));
    const allSmallSlides = Array.from(smallSliderWrapper.querySelectorAll('.swiper-slide'));
    
    console.log('Found slides:', {
      big: allBigSlides.length,
      small: allSmallSlides.length,
      variantFeaturedMediaId: selectedVariantFeaturedMediaId
    });
    
    if (allBigSlides.length === 0 || allSmallSlides.length === 0) {
      console.error('No slides found');
      if (loadingOverlay) loadingOverlay.remove();
      return;
    }
    
    // Filter slides: show common images + selected variant's featured image
    // First, check if the variant's featured image exists in the slides
    let variantFeaturedSlideExists = false;
    allBigSlides.forEach(slide => {
      const mediaId = slide.getAttribute('data-image-id');
      const mediaIdStr = mediaId ? mediaId.toString() : null;
      const featuredMediaIdStr = selectedVariantFeaturedMediaId ? selectedVariantFeaturedMediaId.toString() : null;
      if (mediaIdStr === featuredMediaIdStr) {
        variantFeaturedSlideExists = true;
      }
    });
    
    console.log('Variant featured slide exists in DOM:', variantFeaturedSlideExists);
    
    // If variant's featured image doesn't exist, we need to check if it was removed earlier
    // For now, we'll work with what we have - show/hide slides instead of removing
    // First, restore all slides to check their attributes
    allBigSlides.forEach(slide => {
      if (slide.style.display === 'none') {
        slide.style.display = '';
      }
    });
    allSmallSlides.forEach(slide => {
      if (slide.style.display === 'none') {
        slide.style.display = '';
      }
    });
    
    // Now filter: show common images + selected variant's featured image
    // DON'T remove slides - just hide them so they can be shown later if needed
    const slidesToHideBig = [];
    const slidesToShowBig = [];
    
    allBigSlides.forEach((slide) => {
      const isCommon = slide.getAttribute('data-is-common') === 'true';
      const mediaId = slide.getAttribute('data-image-id');
      // Compare as strings to handle number/string mismatches
      const mediaIdStr = mediaId ? mediaId.toString() : null;
      const featuredMediaIdStr = selectedVariantFeaturedMediaId ? selectedVariantFeaturedMediaId.toString() : null;
      const isSelectedVariantFeatured = featuredMediaIdStr && mediaIdStr && mediaIdStr === featuredMediaIdStr;
      const shouldShow = isCommon || isSelectedVariantFeatured;
      
      console.log('Big slide check:', {
        mediaId: mediaIdStr,
        featuredMediaId: featuredMediaIdStr,
        isCommon,
        isSelectedVariantFeatured,
        shouldShow,
        match: mediaIdStr === featuredMediaIdStr
      });
      
      if (shouldShow) {
        slidesToShowBig.push(slide);
      } else {
        slidesToHideBig.push(slide);
      }
    });
    
    const slidesToHideSmall = [];
    const slidesToShowSmall = [];
    
    allSmallSlides.forEach((slide) => {
      const isCommon = slide.getAttribute('data-is-common') === 'true';
      const mediaId = slide.getAttribute('data-image-id');
      // Compare as strings to handle number/string mismatches
      const mediaIdStr = mediaId ? mediaId.toString() : null;
      const featuredMediaIdStr = selectedVariantFeaturedMediaId ? selectedVariantFeaturedMediaId.toString() : null;
      const isSelectedVariantFeatured = featuredMediaIdStr && mediaIdStr && mediaIdStr === featuredMediaIdStr;
      const shouldShow = isCommon || isSelectedVariantFeatured;
      
      console.log('Small slide check:', {
        mediaId: mediaIdStr,
        featuredMediaId: featuredMediaIdStr,
        isCommon,
        isSelectedVariantFeatured,
        shouldShow
      });
      
      if (shouldShow) {
        slidesToShowSmall.push(slide);
      } else {
        slidesToHideSmall.push(slide);
      }
    });
    
    console.log('Slides to show/hide:', {
      bigShow: slidesToShowBig.length,
      bigHide: slidesToHideBig.length,
      smallShow: slidesToShowSmall.length,
      smallHide: slidesToHideSmall.length
    });
    
    // Check if variant's featured image exists in the slides
    const variantFeaturedSlideBig = allBigSlides.find(slide => {
      const mediaId = slide.getAttribute('data-image-id');
      return mediaId && mediaId.toString() === selectedVariantFeaturedMediaId;
    });
    const variantFeaturedSlideSmall = allSmallSlides.find(slide => {
      const mediaId = slide.getAttribute('data-image-id');
      return mediaId && mediaId.toString() === selectedVariantFeaturedMediaId;
    });
    
    console.log('Variant featured slide check:', {
      featuredMediaId: selectedVariantFeaturedMediaId,
      foundBig: !!variantFeaturedSlideBig,
      foundSmall: !!variantFeaturedSlideSmall,
      allMediaIds: allBigSlides.map(s => s.getAttribute('data-image-id'))
    });
    
    // If variant's featured image doesn't exist in DOM, reload modal with new variant
    if (!variantFeaturedSlideBig && selectedVariantFeaturedMediaId) {
      console.warn('Variant featured image not in DOM, reloading modal with new variant');
      if (loadingOverlay) loadingOverlay.remove();
      
      // Find the modal and opener
      let modal = section.closest('popup-view');
      if (!modal) {
        modal = document.querySelector('popup-view[open]');
      }
      
      if (modal && modal.openedBy) {
        const opener = modal.openedBy;
        const productUrl = opener.getAttribute('data-product-url');
        if (productUrl) {
          // Update URL with new variant
          const urlParts = productUrl.split('?');
          let baseUrl = urlParts[0];
          // Remove existing variant parameter if present
          if (urlParts[1]) {
            const params = new URLSearchParams(urlParts[1]);
            params.delete('variant');
            baseUrl = baseUrl + '?' + params.toString();
          }
          const newUrl = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}view=main-product&variant=${selectedVariantId}`;
          opener.setAttribute('data-product-url', newUrl);
          
          console.log('Reloading modal with URL:', newUrl);
          
          // Create loading box
          const loadingBox = document.createElement('div');
          loadingBox.id = 'variant-loading-box';
          loadingBox.style.cssText = 'position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; padding: 2rem 3rem; border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.15); z-index: 10001; display: flex; flex-direction: column; align-items: center; justify-content: center; min-width: 200px;';
          loadingBox.innerHTML = '<div class="spinner-border" style="width: 2.5rem; height: 2.5rem; border-width: 0.3em; color: #f0a843; margin-bottom: 1rem;"></div><p style="margin: 0; color: #666; font-size: 0.9rem;">Loading product...</p>';
          
          // Close modal and show loading box
          modal.hide();
          
          // Show loading box after a brief delay to ensure modal is closed
          setTimeout(() => {
            document.body.appendChild(loadingBox);
            
            // Reopen modal after a short delay
            setTimeout(() => {
              opener.click();
              
              // Remove loading box when modal reopens (check for modal open)
              const checkModalOpen = setInterval(() => {
                const openModal = document.querySelector('popup-view[open]');
                if (openModal) {
                  if (loadingBox.parentNode) {
                    loadingBox.remove();
                  }
                  clearInterval(checkModalOpen);
                }
              }, 100);
              
              // Fallback: remove loading box after 5 seconds
              setTimeout(() => {
                if (loadingBox.parentNode) {
                  loadingBox.remove();
                }
              }, 5000);
            }, 200);
          }, 100);
          
          return;
        }
      }
    }
    
    // Hide slides that shouldn't be shown (don't remove them)
    slidesToHideBig.forEach(slide => {
      slide.style.display = 'none';
      // Move to end of wrapper so Swiper doesn't see them
      bigSliderWrapper.appendChild(slide);
    });
    slidesToHideSmall.forEach(slide => {
      slide.style.display = 'none';
      // Move to end of wrapper so Swiper doesn't see them
      smallSliderWrapper.appendChild(slide);
    });
    
    // Show slides that should be visible
    slidesToShowBig.forEach(slide => {
      slide.style.display = '';
    });
    slidesToShowSmall.forEach(slide => {
      slide.style.display = '';
    });
    
    // Remove hidden slides for Swiper initialization (Swiper doesn't work well with hidden slides)
    const hiddenBigSlides = bigSliderWrapper.querySelectorAll('.swiper-slide[style*="display: none"]');
    const hiddenSmallSlides = smallSliderWrapper.querySelectorAll('.swiper-slide[style*="display: none"]');
    
    hiddenBigSlides.forEach(slide => slide.remove());
    hiddenSmallSlides.forEach(slide => slide.remove());
    
    // Re-index visible slides
    const visibleBigSlides = bigSliderWrapper.querySelectorAll('.swiper-slide');
    visibleBigSlides.forEach((slide, index) => {
      slide.setAttribute('data-index', (index + 1).toString());
    });
    const visibleSmallSlides = smallSliderWrapper.querySelectorAll('.swiper-slide');
    visibleSmallSlides.forEach((slide, index) => {
      slide.setAttribute('data-index', (index + 1).toString());
    });
    
    // Reinitialize swipers
    setTimeout(() => {
      const smallSliderSelector = section.querySelector(`.slider-small-${product_id}, #slider-small-${product_id}`);
      const bigSliderSelector = section.querySelector(`.slider-big-${product_id}, #slider-big-${product_id}`);
      
      if (!smallSliderSelector || !bigSliderSelector) {
        if (loadingOverlay) loadingOverlay.remove();
        return;
      }
      
      // Find navigation buttons within the section
      const nextBtn = section.querySelector('.button-next');
      const prevBtn = section.querySelector('.button-prev');
      
      var swiper = new Swiper(smallSliderSelector, {
        spaceBetween: 15,
        slidesPerView: 4,
        mousewheel: true,
        slideToClickedSlide: true,
        breakpoints: {
          0: {
            slidesPerView: 3
          },
          320: {
            slidesPerView: 3
          },
          480: {
            slidesPerView: 4
          },
        }
      });
      
      var swiper2 = new Swiper(bigSliderSelector, {
        spaceBetween: 0,
        slidesPerView: 1,
        autoHeight: true,
        slideToClickedSlide: true,
        navigation: nextBtn && prevBtn ? {
          nextEl: nextBtn,
          prevEl: prevBtn
        } : false,
        thumbs: {
          swiper: swiper,
        },
      });
      
      // Navigate to variant's featured image if it exists
      if (selectedVariantFeaturedMediaId) {
        const targetSlide = smallSliderWrapper.querySelector(`.swiper-slide[data-image-id="${selectedVariantFeaturedMediaId}"]`);
        if (targetSlide) {
          const mediaIndex = targetSlide.getAttribute('data-index');
          if (mediaIndex) {
            const slideIndex = parseInt(mediaIndex) - 1;
            if (slideIndex >= 0) {
              swiper2.slideTo(slideIndex, 500, true);
            }
          }
        }
      }
      
      // Remove loading overlay
      if (loadingOverlay) {
        setTimeout(() => {
          loadingOverlay.remove();
          console.log('Loading overlay removed, image update complete');
        }, 300);
      }
      
      console.log('Swipers reinitialized successfully');
    }, 100);
  }
  updateDiscount() {
    var $ProductDiscount = $('#ProductDiscount'),
    $productPrice = $('#ProductPrice'),
    $comparePrice = $('#ComparePrice'),
    $Productlabel = $('.product-label');
    if(this.swatch.price < this.swatch.compare_at_price) {
      $ProductDiscount.html(((this.swatch.compare_at_price - this.swatch.price)*100.0/(this.swatch.compare_at_price)).toFixed());
      $ProductDiscount.show();
      $Productlabel.show();
    }else{
      $ProductDiscount.hide();
      $Productlabel.hide();
    }
  }
  itemsUpdate() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }
  stupdateMasterId() {
    this.swatch = this.stSwatchDate().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  stupdateURL() {
    if (!this.swatch || this.dataset.updateUrl === 'false') return;
    // Reload page with new variant to update images
    window.location.href = `${this.dataset.url}?variant=${this.swatch.id}`;
  }
  changeSwatchInput() {
    const stproductForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    stproductForms.forEach((stproductForm) => {
      const input = stproductForm.querySelector('input[name="id"]');
      input.value = this.swatch.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateSwatchStatuses() {
    const activatedSwatch = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const stinputWrappers = [...this.querySelectorAll('.op-field')];
    stinputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const stoptionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const pastOptionSelected = stinputWrappers[index - 1].querySelector(':checked').value;
      const avOptionInVal = activatedSwatch.filter(variant => variant.available && variant[`option${ index }`] === pastOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.stInAva(stoptionInputs, avOptionInVal)
    });
  }
  stInAva(stlistOfOptions, stlistOfAvOptions) {
    stlistOfOptions.forEach(input => {
      if (stlistOfAvOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.stThemeString.StrunavailableOp.replace('[value]', input.getAttribute('value'));
      }
    });
  }
  stErrortxtRemove() {
    const section = this.closest('section');
    if (!section) return;
    const stproductForm = section.querySelector('cart-action');
    if (stproductForm) stproductForm.stHandErrorTxt();
  }
  includeProInf() {
    const reqSwatchId = this.swatch.id;
    const stScId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(`${this.dataset.url}?variant=${reqSwatchId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      // prevent unnecessary ui changes from abandoned selections
      if (this.swatch.id !== reqSwatchId) return;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const goal = document.getElementById(`price-${this.dataset.section}`);
      const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
      const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
      const skuGoal = document.getElementById(`Sku-${this.dataset.section}`);
      const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
      const invGoal = document.getElementById(`Inventory-${this.dataset.section}`);
      if (source && goal) goal.innerHTML = source.innerHTML;
      if (inventorySource && invGoal) invGoal.innerHTML = inventorySource.innerHTML;
      if (skuSource && skuGoal) {
        skuGoal.innerHTML = skuSource.innerHTML;
        skuGoal.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
      }
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) price.classList.remove('visibility-hidden');
      if (invGoal) invGoal.classList.toggle('visibility-hidden', inventorySource.innerText === '');
      const cartBtUpdated = html.getElementById(`ProductSubmitButton-${stScId}`);
      this.btAddButton(cartBtUpdated ? cartBtUpdated.hasAttribute('disabled') : true, window.stThemeString.Strsoldout);
      live(SP_OBJECT.swatchUpdate, {data: {
        stScId,
        html,
        variant: this.swatch
      }});
    });
  }
  btAddButton(disable = true, text, modifyClass = true) {
    const stproductForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!stproductForm) return;
    const cartBt = stproductForm.querySelector('[name="add"]');
    const cartBtText = stproductForm.querySelector('[name="add"] > span');
    if (!cartBt) return;
    if (disable) {
      cartBt.setAttribute('disabled', 'disabled');
      if (text) cartBtText.textContent = text;
    } else {
      cartBt.removeAttribute('disabled');
      cartBtText.textContent = window.stThemeString.Straddcart;
    }
    if (!modifyClass) return;
  }
  stInaccessible() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const cartBt = button.querySelector('[name="add"]');
    const cartBtText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    if (!cartBt) return;
    cartBtText.textContent = window.stThemeString.Strunavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }
  stSwatchDate() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('selects-box', Swatchoption);

class SwatchCheck extends Swatchoption {
  constructor() {
    super();
  }
  stInAva(stlistOfOptions, stlistOfAvOptions) {
    stlistOfOptions.forEach(input => {
      if (stlistOfAvOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
  itemsUpdate() {
    const varitems = Array.from(this.querySelectorAll('varitem'));
    this.options = varitems.map((varitem) => {
      return Array.from(varitem.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}
customElements.define('pr-option', SwatchCheck);
class StRecomPro extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const sthandleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommrela = html.querySelector('relative-pro');
          if (recommrela && recommrela.innerHTML.trim().length) {
            this.innerHTML = recommrela.innerHTML;
            if($(".shopify-product-reviews-badge").length > 0 && typeof window.SPR == 'function'){
              window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
            }
            if ($('.item-data').length >= 1) {
              $('.item-data').on("click", function() {
                $(this).parents('.option-block').find(".variant-option").removeClass('active-variant');
                $(this).closest('form-wrap').addClass('active-variant');
                var it_img = $(this).attr('dataimg');
                $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('src',it_img);
                $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('srcset',it_img);
                var price = $(this).attr('dataprice');
                var compareprice = $(this).attr('datacompare');
                var stocks = $(this).attr('dataavailable');
                $(this).parents('.single-product-wrap').find('.price-box .new-price').text(Shopify.formatMoney(price, window.money_format));
                if (compareprice > price) {
                  $(this).parents('.single-product-wrap').find('.price-box .old-price').show();
                  $(this).parents('.single-product-wrap').find('.price-box .old-price').html(Shopify.formatMoney(compareprice, window.money_format));
                }else{
                  $(this).parents('.single-product-wrap').find('.price-box .old-price').hide();
                }
              });
            }
            var swiper = new Swiper('#related-slider', {
              slidesPerView: 4,
              grid: {
                rows: 1,
                fill: 'row' | 'column',
              },
              spaceBetween: 30,
              observer: true,
              observeParents: true,
              watchSlidesProgress: true,
              breakpoints: {
                0: {
                  slidesPerView: 1,
                  grid: {
                    rows: 1,
                    fill: 'row' | 'column',
                  },
                  spaceBetween: 12
                },
                320: {
                  slidesPerView: 1,
                  grid: {
                    rows: 1,
                    fill: 'row' | 'column',
                  },
                  spaceBetween: 12
                },
                360: {
                  slidesPerView: 2,
                  grid: {
                    rows: 1,
                    fill: 'row' | 'column',
                  },
                  spaceBetween: 12
                },
                540: {
                  slidesPerView: 2,
                  grid: {
                    rows: 1,
                    fill: 'row' | 'column',
                  },
                  spaceBetween: 12
                },
                640: {
                  slidesPerView: 2,
                  grid: {
                    rows: 1,
                    fill: 'row' | 'column',
                  },
                  spaceBetween: 12
                },
                768: {
                  slidesPerView: 2,
                  grid: {
                    rows: 1,
                    fill: 'row' | 'column',
                  },
                  spaceBetween: 30
                },
                1024: {
                  slidesPerView: 3,
                  grid: {
                    rows: 1,
                    fill: 'row' | 'column',
                  },
                  spaceBetween: 30
                },
                1199: {
                  slidesPerView: 4,
                  grid: {
                    rows: 1,
                    fill: 'row' | 'column',
                  },
                  spaceBetween: 30
                },
                1499: {
                  slidesPerView: 4,
                  grid: {
                    rows: 1,
                    fill: 'row' | 'column',
                  },
                  spaceBetween: 30
                }
              }
            });
          }
          setTimeout(function () {
              $(".wishlist-custom-action").each(function() {
                var attr = $(this).attr("data-handle");
                if (localStorage.getItem('user_wishlist_cnt') !== null) {
                  var existing_wishlist = JSON.parse(localStorage.getItem('wishlist'));
                  if ($.inArray(attr, existing_wishlist)>=0){
                   $(this).addClass('active-wishlist');
                   $(this).removeClass('wishlist-custom-action');
                  }
                  $('.wishlist-counter').text(localStorage.getItem('user_wishlist_cnt'));
                }else{
                  $('.wishlist-counter').text('0');
                }
              });
          });
          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };
    new IntersectionObserver(sthandleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}
customElements.define('relative-pro', StRecomPro);
class ajaxSearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        stdebounce((event) => {
          this.triggerChange(event);
        }, 300).bind(this)
      );
    }
  }
  ajaxResetBtn() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }
  triggerChange() {
    this.ajaxResetBtn();
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the ajax search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.ajaxResetBtn();
    }
  }
}
customElements.define('search-form', ajaxSearchForm);

if (!customElements.get('popup-view')) {
  customElements.define('popup-view', class QuickAddModal extends stModalcontent {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }
    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('ajax-cart');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';
      if (preventFocus) this.openedBy = null;
      super.hide();
    }
    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.ajax-loader').classList.remove('hidden');
      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          this.preSwatchURLswapping();
          this.preSelectVariant(opener);
          // Initialize Swiper in modal after content is loaded
          this.initializeModalSwipers();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.ajax-loader').classList.add('hidden');
        });
    }
    setInnerHTML(element, html) {
      element.innerHTML = html;
      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }
    preSwatchURLswapping() {
      const variantPicker = this.modalContent.querySelector('pr-option,selects-box');
      if (!variantPicker) return;
      variantPicker.setAttribute('data-update-url', 'false');
    }
    preSelectVariant(opener) {
      const productUrl = opener.getAttribute('data-product-url');
      if (!productUrl) return;
      
      // Extract variant ID from URL
      const urlParts = productUrl.split('?');
      if (urlParts.length < 2) return;
      const urlParams = new URLSearchParams(urlParts[1]);
      const variantId = urlParams.get('variant');
      if (!variantId) return;
      
      const variantPicker = this.modalContent.querySelector('pr-option,selects-box');
      if (!variantPicker) return;
      
      // Find variant data from JSON script
      const variantDataScript = variantPicker.querySelector('script[type="application/json"]');
      if (!variantDataScript) return;
      
      try {
        const variants = JSON.parse(variantDataScript.textContent);
        const targetVariant = variants.find(v => v.id.toString() === variantId.toString());
        if (!targetVariant) return;
        
        // Wait a bit for the variant picker to be fully initialized
        setTimeout(() => {
          // For selects-box (dropdown)
          const selects = variantPicker.querySelectorAll('select');
          if (selects.length > 0) {
            selects.forEach((select, index) => {
              const optionValue = targetVariant[`option${index + 1}`];
              if (optionValue && select.value !== optionValue) {
                select.value = optionValue;
                select.dispatchEvent(new Event('change', { bubbles: true }));
              }
            });
          } else {
            // For pr-option (swatch/radio buttons)
            // Group radio buttons by option index
            const optionGroups = {};
            variantPicker.querySelectorAll('input[type="radio"]').forEach(input => {
              const name = input.name || input.closest('.op-field, .variant-option-block')?.querySelector('h6, .option-title')?.textContent;
              if (!name) return;
              if (!optionGroups[name]) optionGroups[name] = [];
              optionGroups[name].push(input);
            });
            
            // Select the correct option for each group
            Object.keys(optionGroups).forEach((groupName, index) => {
              const optionValue = targetVariant[`option${index + 1}`];
              if (optionValue) {
                const matchingInput = optionGroups[groupName].find(input => input.value === optionValue);
                if (matchingInput && !matchingInput.checked) {
                  matchingInput.checked = true;
                  matchingInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }
            });
          }
        }, 200);
      } catch (e) {
        console.error('Error parsing variant data:', e);
      }
    }
    initializeModalSwipers() {
      // Wait for scripts to execute
      // NOTE: Don't remove hidden slides - keep them in DOM for variant switching
      // Swiper will handle hidden slides, or we can filter them out during initialization
      setTimeout(() => {
        const modalSection = this.modalContent.querySelector('section[id^="MainProduct-"]');
        if (!modalSection) return;
        
        const bigSliderWrapper = modalSection.querySelector('.slider-big .swiper-wrapper, [id^="slider-big-"] .swiper-wrapper');
        const smallSliderWrapper = modalSection.querySelector('.slider-small .swiper-wrapper, [id^="slider-small-"] .swiper-wrapper');
        
        if (bigSliderWrapper && smallSliderWrapper) {
          // Move hidden slides to the end (but keep them in DOM)
          function isHidden(element) {
            return element.style.display === 'none' || 
                   window.getComputedStyle(element).display === 'none';
          }
          
          const allBigSlides = Array.from(bigSliderWrapper.querySelectorAll('.swiper-slide'));
          const hiddenBigSlides = allBigSlides.filter(slide => isHidden(slide));
          const visibleBigSlides = allBigSlides.filter(slide => !isHidden(slide));
          
          // Reorder: visible slides first, then hidden ones
          visibleBigSlides.forEach(slide => bigSliderWrapper.appendChild(slide));
          hiddenBigSlides.forEach(slide => bigSliderWrapper.appendChild(slide));
          
          const allSmallSlides = Array.from(smallSliderWrapper.querySelectorAll('.swiper-slide'));
          const hiddenSmallSlides = allSmallSlides.filter(slide => isHidden(slide));
          const visibleSmallSlides = allSmallSlides.filter(slide => !isHidden(slide));
          
          // Reorder: visible slides first, then hidden ones
          visibleSmallSlides.forEach(slide => smallSliderWrapper.appendChild(slide));
          hiddenSmallSlides.forEach(slide => smallSliderWrapper.appendChild(slide));
          
          // Re-index visible slides only
          visibleBigSlides.forEach(function(slide, index) {
            slide.setAttribute('data-index', (index + 1).toString());
          });
          
          visibleSmallSlides.forEach(function(slide, index) {
            slide.setAttribute('data-index', (index + 1).toString());
          });
        }
      }, 1200); // Wait a bit longer than the template script timeout (1000ms)
    }
    removeDOMElements() {
      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }
    preventDuplicatedIDs() {
      const stScId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(stScId, `quickadd-${ stScId }`);
      this.productElement.querySelectorAll('selects-box, pr-option, product-info').forEach((element) => {
        element.dataset.originalSection = stScId;
      });
    }
  });
}
if (!customElements.get('cart-action')) {
  customElements.define('cart-action', class stProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.triggerSendHand.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('ajax-cart');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('ajax-cart')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }
    triggerSendHand(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.stHandErrorTxt();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.ajax-loader').classList.remove('hidden');
      const config = stFetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.fetchSecToInclude().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      fetch(`${routes.increase_cart_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.stHandErrorTxt(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) live(SP_OBJECT.ajxcartRefresh, {source: 'cart-action'});
          this.error = false;
          const quickAddModal = this.closest('popup-view');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.ajax-loader').classList.add('hidden');
        });
    }
    stHandErrorTxt(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.pr-form-error');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.pr-form-error-text');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}